import { type BlokProps, StoryblokComponent } from "@trydig/storyblok";
import { clsx } from "@trydig/ui";
import { BlokWrap } from "~/components/bloks/BlokWrap";
import type { QuoteStoryblok } from "~/generated/sb/blok-types";
import styles from "./QuoteBlok.module.css";

const alignmentClasses = {
	left: "",
	center: styles.center,
	right: styles.right,
};

export const QuoteBlok = ({ blok, preview }: BlokProps<QuoteStoryblok>) => {
	const aligmentClass: string | undefined =
		alignmentClasses[blok.align as keyof typeof alignmentClasses];

	return (
		<BlokWrap
			className={clsx(styles.root, aligmentClass)}
			data-layout="blok"
			data-container="large"
			editable={blok}
		>
			<div className={styles.wrapper}>
				<div className={styles.tags}>
					<BoldTag blok={blok} preview={preview} />
					<RegularTag blok={blok} preview={preview} />
				</div>
				<Heading blok={blok} preview={preview} />
				<CallToAction blok={blok} preview={preview} />
			</div>
		</BlokWrap>
	);
};

const BoldTag = ({ blok }: BlokProps<QuoteStoryblok>) =>
	!blok.boldTag ? null : <strong>{blok.boldTag}</strong>;

const RegularTag = ({ blok }: BlokProps<QuoteStoryblok>) =>
	!blok.regularTag ? null : <span>{blok.regularTag}</span>;

const Heading = ({ blok }: BlokProps<QuoteStoryblok>) =>
	!blok.heading ? null : <h2 className="blok-title">{blok.heading}</h2>;

const CallToAction = ({ blok, preview }: BlokProps<QuoteStoryblok>) => {
	const cta = blok.cta?.[0];
	return cta ? (
		<div className={styles.cta}>
			<StoryblokComponent type="button" blok={cta} preview={preview} />
		</div>
	) : null;
};
